<div class="d-flex flex-column mx-2 px-4 py-2 h-100 cx-one-ui">
    <!-- Loading animation -->
    <cv-loader *ngIf="showLoader"></cv-loader>

    <!-- Header -->
    <div class="d-flex align-items-end justify-content-between border-bottom managementHeader mt-4" aria-labelledby="manageDashboardsHeader">
        <h1 class="text-nowrap managementHeaderText" role="heading" cvLocalizedText langSection="Manage_Reports" langKey="Manage_Reports"
            aria-level="1" id="manageDashboardsHeader">
            Manage Reports
        </h1>
    </div>

    <div class="d-flex align-items-end justify-content-between border-bottom managementHeader" aria-labelledby="manageDashboardsHeader">
        <!-- New Template Report button -->
        <button (click)= "openCreateNewReportModal()" class="btn header-btn ml-0 mt-3" cvLocalizedText langSection="Manage_Reports" langKey="New_Template_Report">
        </button>
        <!-- Search -->
        <div class="cxone-live-search">
            <cxone-text-input type="search"
                              autocomplete="off"
                              class="cxone-reports-search"
                              [placeholder]="getLocaleText('Find_Reports', 'Start typing to find reports')"
                              [(ngModel)]="this.filterValue"
                              (ngModelChangeDebounced)="filterValue"
                              [ngModelChangeDebounceTime]="500"
                              (keyup)="applyFilter()">
            </cxone-text-input>
            <i class="icon-search" [hidden]="filterValue.length !== 0">
                <svg class="icon-18 fill-iconDefault-noHover search-wrapper">
                    <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                </svg>
            </i>
            <i class="icon-search" [hidden]="filterValue.length === 0" (click)="clearFilter()">
                <svg class="icon-18 fill-iconDefault-noHover close-wrapper">
                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </i>
        </div>
    </div>

    <!-- Main -->
    <main class="managementBody mt-4">
        <div class="row">
            <div class="col-12 cxoneDashboardsGrid">
                <!-- Grid -->
                <ag-grid-angular #manageReportsGrid *ngIf="gridOptions !== null" class="ag-theme-balham flex-fill" [gridOptions]="gridOptions">
                </ag-grid-angular>
            </div>
        </div>
    </main>
</div>
